import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/** Friendly "lost dog" illustration for bootstrap / config failure screens. */
export const LostDogIcon: React.FC<SvgIconProps> = (props) => (
    <SvgIcon viewBox="0 0 120 120" {...props}>
        <ellipse cx="60" cy="98" rx="28" ry="6" fill="currentColor" opacity="0.12" />
        <path
            d="M34 52c-2-14 8-26 22-28 16-2 30 8 32 24 1 8-2 16-8 21l4 18c1 4-3 7-7 5l-10-6c-4 2-9 3-14 3-12 0-22-8-24-20l-5-17z"
            fill="currentColor"
            opacity="0.18"
        />
        <path
            d="M38 50c-1-12 9-22 21-24 13-2 25 6 27 19 1 7-1 14-6 18l3 15c1 3-2 6-6 4l-9-5c-3 2-7 2-11 2-10 0-18-7-20-17l-4-12z"
            fill="currentColor"
        />
        <circle cx="48" cy="48" r="3.5" fill="#fff" />
        <circle cx="48" cy="48" r="1.8" fill="currentColor" />
        <circle cx="66" cy="48" r="3.5" fill="#fff" />
        <circle cx="66" cy="48" r="1.8" fill="currentColor" />
        <path
            d="M52 58c3 3 8 3 11 0"
            fill="none"
            stroke="#fff"
            strokeWidth="2"
            strokeLinecap="round"
        />
        <ellipse cx="34" cy="42" rx="7" ry="11" fill="currentColor" transform="rotate(-18 34 42)" />
        <ellipse cx="82" cy="42" rx="7" ry="11" fill="currentColor" transform="rotate(18 82 42)" />
        <path
            d="M78 24c6-8 16-10 22-4 4 4 2 10-2 14"
            fill="none"
            stroke="currentColor"
            strokeWidth="3"
            strokeLinecap="round"
        />
        <circle cx="96" cy="18" r="2.5" fill="currentColor" opacity="0.55" />
        <circle cx="102" cy="24" r="1.8" fill="currentColor" opacity="0.4" />
        <text
            x="88"
            y="14"
            fill="currentColor"
            fontSize="10"
            fontWeight="700"
            opacity="0.65"
        >
            ?
        </text>
    </SvgIcon>
);
